module.exports = __webpack_public_path__ + "media/sunbursts.e2f70146.mp3";